import SelectOrganization from '@/components/SelectOrganization';
import SelectOrganizationAndRole from '@/components/SelectOrganizationAndRole';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { Accordion, AccordionDetails, AccordionSummary, styled, Typography } from '@mui/material';
import { createFileRoute } from '@tanstack/react-router';
import { useFlag } from '@unleash/proxy-client-react';

export const Route = createFileRoute('/_auth/switchOrganization')({
    component: SwitchOrganizationComponent,
})

const Spacer = styled('div')(() => ({
    position: 'relative',
    height: '30px',
}));

function SwitchOrganizationComponent() {

    const scoreg_core_features = useFlag('scoreg_core_features');
    //console.log('reset session')
    //sessionStorage.removeItem('permission');
    //sessionStorage.removeItem('member');
    //sessionStorage.removeItem('organization');

    return (
        <>
            {scoreg_core_features && <>
                Zugewiesene Organisationen:
            </>}
            <SelectOrganization />

            {scoreg_core_features && <>
                <Spacer />
                <Accordion disableGutters elevation={0} square>
                    <AccordionSummary
                        expandIcon={<ArrowDownwardIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Typography component="span">Erweiterte Optionen (ROOT)</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <SelectOrganizationAndRole />
                    </AccordionDetails>
                </Accordion>
            </>}
        </>
    )
}